import firebaseConfig from '../config/firebaseConfig';
import firebase from "firebase";
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

class FirestoreService {
  constructor(collectionName) {
    this.collectionName = collectionName;
    this.projectEnquiryRef = firebase.firestore().collection(this.collectionName);
  }
// getter for retriving document from firestore
  getData = async () => {
    try {
      const result = await this.projectEnquiryRef.get();
      return result.docs.map(doc => doc.data());
    }
    catch(error) {
      window.alert('404 error');
    }
  }
// getter for retriving hashed user data from firestore
  getHashedUserData = async () => {
    try {
        const result = await this.projectEnquiryRef.get();
        return result.docs.map(doc => doc.data());
      }
    catch(error) {
        window.alert('404 error');
      }
    }
// adder for adding document to firestore
  addData = async (data) => {
    try {
      const response = await this.projectEnquiryRef.add(data);
      window.alert('Query Submitted');
    }
    catch(error){
      window.alert('empty fields', error);
    }

  }
  // adder for adding document to firestore
    addUserInfo = async (data) => {
        try {
          await this.projectEnquiryRef.add(data);
        }
        catch(error){
          window.alert('error : query not submitted');
        }
    }
    // adder for adding document to firestore
    logUser = async (data) => {
        try{
          await this.projectEnquiryRef.add(data);
        }
        catch(error){
          return;
        }
    }
}



export {
  FirestoreService
};
